import React from 'react';

import { ReactComponent as AttachmentIcon } from '@assets/icons/attachment.svg';

import {
  FileAttachmentProps,
  TimelineAction,
  TimelineEntity
} from '../../types/leadActivity';

const FileAttachment: React.FC<FileAttachmentProps> = ({
  modifiedData,
  actionType,
  entity
}) => {
  const documentData = modifiedData.find((d) => d.document);

  if (!documentData?.document?.[0]) return null;

  const file = documentData.document[0];
  const isDeleted = file.deleted_at && file.deleted_at !== null;

  if (
    entity === TimelineEntity.LEAD_ATTACHMENTS &&
    actionType === TimelineAction.DELETE &&
    !isDeleted
  ) {
    return null;
  }

  const bgColor = isDeleted ? 'bg-gray-100' : 'bg-green-50';
  const textColor = isDeleted ? 'text-gray-400' : 'text-green-600';
  const borderColor = isDeleted ? 'border-gray-300' : 'border-gray-200';
  const fileNameColor = isDeleted ? 'text-gray-500' : 'text-gray-900';

  return (
    <div className="mt-2">
      <div
        className={`inline-flex items-center gap-1 rounded-lg border ${borderColor} bg-white px-3 py-2 ${
          isDeleted ? 'opacity-60' : ''
        }`}
      >
        <div
          className={`flex size-8 items-center justify-center rounded-full ${bgColor}`}
        >
          <AttachmentIcon className={`size-4 ${textColor}`} />
        </div>
        <span
          className={`text-sm ${fileNameColor} ${
            isDeleted ? 'line-through' : ''
          }`}
        >
          {file.file_name}
        </span>
        {isDeleted && (
          <span className="ml-2 rounded bg-gray-100 px-2 py-1 text-xs text-gray-400">
            Deleted
          </span>
        )}
      </div>
    </div>
  );
};

export default FileAttachment;
